import { useContext } from "react";
import { contextTheme } from "../contexts/ProviderTheme";

export default function BannerInfo01() {
  const { theme } = useContext(contextTheme);

  const style = {
    backgroundColor: !theme ? "#FFF" : "#333",
    color: !theme ? "#333" : "#FFF",
    fontC: {
      color: !theme ? "#333" : "#FFF",
    }
  };
  return (
    <div className="banner-info0" style={style}>
      <h1 style={style.fontC}>CON CADA COMPRA QUE HAGAS</h1>
      <h1 style={style.fontC}>OBTIENES <b style={{color:"red"}}>$STORE</b></h1>

      <span style={style.fontC}>
        As&iacute; podr&aacute;s optar por descuentos en todos nuestros productos. 
      </span>

      <a rel="noreferrer" title="Deseo conocer mas acerca del la tienda virtual blockchain" href="https://api.whatsapp.com/send?phone=+584128256644&amp;text=Hola%2C%20deseo%20conocer%20mas%20acerca%20de%20tienda%20virtual%20blockchain" target="_blank" style={style.fontC}>
        Deseo saber m&aacute;s <i className="fas fa-chevron-right"></i>
      </a>
    </div>
  );
}
